import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import "./styles/layout/layout.scss";
import AppLayout from "./components/Layout/AppLayout";
import LoginPage from "./pages/Login/LoginPage";
import AuthHandler from "./components/AuthHandler/AuthHandler";
import MaintenanceGate from "./pages/Maintenance/MaintenanceGate";
import useMaintenanceService from "./services/SuperAdmin/maintenanceService";
import { setMaintenanceEnabled } from "./state/slices/generalSlice";

function App() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("api_token");
  const urlToken = new URLSearchParams(window.location.search).get("token");
  const isAuthenticated = !!(token || urlToken);
  const maintenanceBlocked = useSelector(
    (state) => state.generalSlice.maintenanceBlocked,
  );
  const { getMaintenanceStatus, statusResponse } = useMaintenanceService();

  useEffect(() => {
    getMaintenanceStatus().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (statusResponse) {
      dispatch(setMaintenanceEnabled(Boolean(statusResponse?.data?.is_enabled)));
    }
  }, [statusResponse, dispatch]);

  return (
    <>
      <AuthHandler />
      {isAuthenticated && maintenanceBlocked ? (
        <MaintenanceGate />
      ) : isAuthenticated ? (
        <AppLayout />
      ) : (
        <LoginPage />
      )}
    </>
  );
}

export default App;
